import React, { FC } from 'react'

import { SpinnerProps } from './Spinner.types'
import { StyledSpinner, StyledDoubleBounce } from './Styled'

export const Spinner: FC<SpinnerProps> = () => {
  return (
    <StyledSpinner data-testid='Spinner'>
      <StyledDoubleBounce />
      <StyledDoubleBounce inverted />
    </StyledSpinner>
  )
}
